module.exports = __webpack_public_path__ + "img/CC.ec25705c.png";